<template>
  <VApp>
    <VMain style="background: #EEF3FA;">
      <div class="mx-sm-2 mx-md-7">
        <VContainer>
          <slot />
        </VContainer>
      </div>
    </VMain>
  </VApp>
</template>

<script>
export default {
  name: 'IntegrationsLayout',
};
</script>

<style scoped>

</style>
